import { getValidRedirectUrl } from '../entities/utils/getValidRedirectUrl';

const REFERER_URL_SESSION_KEY = 'tn:sisuRefererUrl';

function persistRefererUrlToSession(refererUrl: string): void {
    if (typeof window === 'undefined') return;
    try {
        const validRefererUrl = getValidRedirectUrl(refererUrl);

        if (validRefererUrl) {
            window.sessionStorage.setItem(REFERER_URL_SESSION_KEY, validRefererUrl);
        }
    } catch {}
}

function readRefererUrlFromSession(): string | null {
    if (typeof window === 'undefined') return null;
    try {
        const refererUrl = window.sessionStorage.getItem(REFERER_URL_SESSION_KEY);
        const validRefererUrl = getValidRedirectUrl(refererUrl);

        if (refererUrl && !validRefererUrl) {
            clearRefererUrlFromSession();
        }

        return validRefererUrl;
    } catch {
        return null;
    }
}

function clearRefererUrlFromSession(): void {
    if (typeof window === 'undefined') return;
    try {
        window.sessionStorage.removeItem(REFERER_URL_SESSION_KEY);
    } catch {}
}

export { clearRefererUrlFromSession, persistRefererUrlToSession, readRefererUrlFromSession };
